<template>
  <div class="mb-[3.25rem] text-center">
    <div class="inline-block rounded border border-co-success-500 bg-white">
      <div class="rounded-t border-co-success-500 bg-co-success-500 px-8 py-4 text-center">
        <h3 class="co-display-10 mb-0 font-bold text-white">
          早めの申し込み・入金がお得！
          <span class="text-co-yellow-500">
            今日から学習スタート！！
          </span>
        </h3>
      </div>
      <div class="p-5 text-left md:text-center">
        <p class="mb-4">
          お申し込み後、入金が完了すると受講開始日を待たず
          <br class="hidden md:block">
          <b class="text-co-danger-500">
            すぐにチャットサポートと課題提出を開始
          </b>
          できます。
        </p>
        <slot name="notes">
          <p class="co-display-13 mb-2 text-co-gray-400">
            ※メンタリングは通常の受講期間内での実施となります。
          </p>
          <p class="co-display-13 mb-0 text-co-gray-400">
            ※先割の場合は通常よりも3週間早く受講を開始できます。
          </p>
        </slot>
      </div>
    </div>
  </div>
</template>
